import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { BaseClickable, palette, SolvTheme, Stack, Text } from '@solvhealth/jigsaw-v1';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import BookUrgentCare from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/components/BookUrgentCare';
import BookVideoVisit from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/components/BookVideoVisit';
import MentalHealth from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/components/MentalHealth';
import Triage from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/components/Triage/Triage';
import { LOCATION_SELECTOR_MODAL } from '~/components/AccountGetsMarried/components/UserGeoLocationSelector';
import useShowLabs from '~/components/AccountGetsMarried/constants/hooks/useShowLabs';
import useStateData from '~/components/BookingFlow/hooks/useStateData';
import { analyticsTrackEvent } from '~/core/analytics';
import { TRIAGE_ENTRYPOINT_ACCOUNT_HOME, TRIAGE_ENTRYPOINT_VISIBLE } from '~/core/analytics/events';
import { getAgeFromBirthDate } from '~/core/util/date';
import { biggerThanOrEqualTo } from '~/core/util/styledComponents';
import useUserPosition, { PositionTrigger } from '~/hooks/geo/useUserPosition';
import useToggleRuntimeModal from '~/hooks/runtime/useToggleRuntimeModal';
import { useCurrentCareRegion } from '~/hooks/useCurrentCareRegion';
import useSelectActiveUserProfile from '~/hooks/useSelectActiveUserProfile';
import { useTriageEnabled } from '~/hooks/useTriageEnabled';
import BookLabTest from '../NavTiles/components/BookLabTest';

const Content = styled.div.withConfig({ componentId: 'sc-81hpkw-0' })`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${biggerThanOrEqualTo.sm`
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: minmax(100px, auto);
    padding-left: 24px;
    padding-right: 24px;
    max-width: ${SolvTheme.breakpoints.lg};
    margin: 0 auto;
    box-sizing: border-box;
  `}
  ${biggerThanOrEqualTo.lg`
    grid-template-columns: repeat(4, 1fr);
  `}
`;

function VerticalModalities() {
  const triageEnabled = useTriageEnabled();

  const [, toggleLocationModal] = useToggleRuntimeModal(LOCATION_SELECTOR_MODAL);
  const location = useSelector((state) => state.searchPreferences.location);
  const { position } = useUserPosition(PositionTrigger.IPOnly);
  const { t } = useTranslation(['account', 'common']);
  const locationLabel = location?.label ?? position.result?.label ?? t('common:currentLocation');
  const showLabs = useShowLabs();

  return (
    <Stack space={2} width="100%">
      <Stack alignItems="flex-start" px={3}>
        <Text variant="h3">{t('account:home.findCare.title')}</Text>
        <BaseClickable
          endIcon={<ExpandMoreIcon htmlColor={palette.gray[600]} style={{ fontSize: '14px' }} />}
          flexGrow={0}
          onClick={toggleLocationModal}
        >
          <Text>{locationLabel}</Text>
        </BaseClickable>
      </Stack>

      <Content>
        <BookUrgentCare />
        <BookVideoVisit />
        {showLabs && <BookLabTest />}
        <MentalHealth />
        {triageEnabled && <Triage entrypoint={TRIAGE_ENTRYPOINT_ACCOUNT_HOME} />}
      </Content>
    </Stack>
  );
}

export default VerticalModalities;
